<mat-horizontal-stepper
  *transloco="let t"
  [@.disabled]="true"
  [linear]="isLinear"
  #stepper
  labelPosition="bottom"
  (selectionChange)="changeStep($event)"
>
  <ng-template matStepperIcon="edit">
    <mat-icon>check</mat-icon>
  </ng-template>
  <mat-step
    label="{{ t('step1.eh-mydocuments-step1-selection') }}"
    [completed]="areProductsSelected"
  >
    <div *ngIf="isAuthError || callFailedIsShown" class="div-error">
      <h1 class="error-h1">{{ t("eh-mydocuments-error1") }}</h1>
    </div>
    <div class="mat-step-container-form" *ngIf="documentItems?.length">
      <div class="wizard-form">
        <h1 *ngIf="!isAuthError" class="stepper-title">
          {{ t("step1.eh-mydocuments-step1-title") }}
        </h1>
        <div
          *ngIf="!isAuthError"
          class="checkbox-container checkbox-padding container-without-padding container-border"
        >
          <mat-checkbox
            class="mat-checkbox-step1"
            color="primary"
            [checked]="areAllProductsSelected"
            (change)="onChangeAllProductsSelection($event)"
          >
            <div class="image-with-span-container">
              <div class="span-container">
                <span class="select-all"
                  >{{ t("step1.eh-mydocuments-step1-selectall") }}
                  <span *ngIf="countCheckboxChecked !== 0"
                    >({{ countCheckboxChecked }})</span
                  >
                  <span
                    *ngIf="
                      countCheckboxChecked === 0 &&
                      uniqueSessionIdByDocumentItems
                    "
                    >({{ selectableDocumentsCount }})</span
                  >
                </span>
              </div>
            </div>
          </mat-checkbox>
          <div *ngIf="documentItems?.length">
            <div class="checkbox-container">
              <div
                class="side-padding"
                [ngClass]="
                  !isProductItemHasDocuments[option?.posNumber]
                    ? 'document-checkbox-disabled'
                    : ''
                "
                *ngFor="let option of documentItems; let i = index"
              >
                <mat-checkbox
                  class="checkbox-with-image-container"
                  color="primary"
                  [checked]="isProductItemChecked[option?.posNumber]"
                  [disabled]="!isProductItemHasDocuments[option?.posNumber]"
                  (change)="onChangeProductSelection($event, option)"
                >
                  <div class="image-with-span-container">
                    <img
                      class="item-image"
                      src="{{ option?.picturePoolLink }}"
                      alt=""
                      width="40"
                      height="40"
                      style="margin: 0px 1.5rem 0px 1rem !important"
                    />
                    <div class="span-container">
                      <span class="product-name">
                        {{
                          productItemTextInActiveLanguage[option?.posNumber]
                        }}</span
                      >
                      <span class="product-code">{{ option?.orderCode }}</span>
                      <span
                        class="product-code"
                        *ngIf="
                          !(option?.orderCode && option?.orderCodeExtended)
                        "
                      >
                        {{ option?.materialNumber }}</span
                      >
                      <span
                        class="product-order"
                        [class.order-disabled]="
                          !isProductItemHasDocuments[option?.posNumber]
                        "
                      >
                        {{ t("step1.eh-mydocuments-step1-position") }}
                        {{ option?.posNumber }}</span
                      >
                      <ng-container>
                        <span
                          *ngIf="!isProductItemHasDocuments[option?.posNumber]"
                          class="product-info"
                        >
                          <mat-icon
                            class="product-info-icon"
                            svgIcon="eh-info"
                          ></mat-icon>
                          {{
                            t(
                              "step1.eh-mydocuments-step1-no-documents-available"
                            )
                          }}
                        </span>
                      </ng-container>
                    </div>
                  </div>
                </mat-checkbox>
              </div>
              <div class="productOfProducts side-padding">
                <p>
                  {{
                    t("step1.eh-mydocuments-step1-nrproducts", {
                      countCheckboxChecked: countCheckboxChecked,
                      documentProductsCount:
                        uniqueSessionIdByDocumentItems?.length
                    })
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div
        class="step-buttons step-buttons-first"
        [ngClass]="[
          isEndOfWizard ? 'step-buttons-absolute' : 'step-buttons-fixed'
        ]"
      >
        <div class="step-buttons-center">
          <button
            (click)="navigateBackInBrowserHistory()"
            class="step-button-back step-first-button"
            mat-raised-button
            color="primary"
            matStepperPrevious
          >
            {{ t("eh-mydocuments-back") }}
          </button>
          <button
            (click)="trackNextStepProduct()"
            class="stepper-button next-step-button first-next-step-button"
            [disabled]="!areProductsSelected"
            mat-raised-button
            color="primary"
            matStepperNext
          >
            {{ t("eh-mydocuments-next") }}
          </button>
        </div>
      </div>
    </div>
  </mat-step>

  <mat-step
    label="{{ t('step2.eh-mydocuments-step2-selection') }}"
    [completed]="areDocumentTypesValid && areCadDrawingsValid"
  >
    <div *ngIf="isAuthError || callFailedIsShown" class="div-error">
      <h1 class="error-h1">{{ t("eh-mydocuments-error1") }}</h1>
    </div>
    <div class="form-document-group-container">
      <div class="wizard-form">
        <h1 class="stepper-title">
          {{ t("step2.eh-mydocuments-step2-title") }}
        </h1>
        <div class="checkbox-container checkbox-padding container-border">
          <div
            *ngFor="
              let documentValue of orderedDocumentTypes
                | slice : 0 : (showMoreDocuments ? undefined : 6);
              let i = index
            "
            class="side-padding"
          >
            <div class="more-documents-language-types" *ngIf="i === 6">
              {{ t("step2.eh-mydocuments-step2-moredocs") }}
            </div>
            <mat-checkbox
              [disabled]="
                isDocumentTypeAvailableAfterProduction[documentValue?.docTypeId]
              "
              [checked]="isDocumentTypeChecked[documentValue?.docTypeId]"
              class="checkbox-with-image-container"
              [ngClass]="i === 0 ? 'checkbox-container--first' : ''"
              color="primary"
              (change)="onCheckboxChange($event, i, documentValue)"
            >
              <div class="title-container">
                <div class="document-title">
                  <span class="document-type">
                    {{
                      documentTextInActiveLanguage[documentValue?.docTypeId]
                    }}</span
                  >
                  <div
                    class="document-type"
                    *ngIf="
                      isDocumentTypeAvailableAfterProduction[
                        documentValue?.docTypeId
                      ]
                    "
                  >
                    <mat-icon
                      class="product-info-icon"
                      svgIcon="eh-info"
                    ></mat-icon>
                    <span class="available-product-title">{{
                      t("step2.eh-mydocuments-step2-availability")
                    }}</span>
                  </div>
                </div>
              </div>
            </mat-checkbox>
            <div
              *ngIf="
                documentValue?.docTypeId === 11 && isDocumentTypeChecked[11]
              "
            >
              <div
                class="select-container"
                *ngFor="
                  let selectedCadFileTypeView of selectedCadFileTypeViews;
                  let viewIndex = index;
                  let isLast = last;
                  let isFirst = first
                "
              >
                <div class="first-multiselect">
                  <span class="select-box-label">{{
                    t("eh-mydocuments-cad-view")
                  }}</span>

                  <ng-multiselect-dropdown
                    class="cad-dropdown"
                    placeholder="{{ t('eh-mydocuments-cad-selectview') }}"
                    [settings]="dropdownSettingsView"
                    [data]="uniques"
                    (onSelect)="setSelectedCadFileTypeView($event, viewIndex)"
                  >
                  </ng-multiselect-dropdown>
                </div>
                <div class="second-multiselect">
                  <span class="select-box-label">{{
                    t("eh-mydocuments-cad-format")
                  }}</span>

                  <ng-multiselect-dropdown
                    class="cad-dropdown"
                    placeholder="{{ t('eh-mydocuments-cad-selectformat') }}"
                    [settings]="dropdownSettings"
                    [data]="cadFileTypeWithUniqueFormats"
                    (onSelect)="setSelectedCadFileTypeFormat($event, viewIndex)"
                    (onDeSelect)="onItemDeSelect($event, viewIndex)"
                    (onSelectAll)="onSelectAll($event, viewIndex)"
                    (onDeSelectAll)="onDeSelectAll($event, viewIndex)"
                    #selectedFormat
                  >
                  </ng-multiselect-dropdown>
                </div>
                <div class="delete-container">
                  <mat-icon
                    *ngIf="
                      !isLast ||
                      (selectedCadFileTypeView.cadFormat &&
                        selectedCadFileTypeView.cadFileTypes.length &&
                        selectedCadFileTypeViews.length > 1)
                    "
                    class="product-delete-icon"
                    svgIcon="eh-delete"
                    (click)="deleteSelectedCadFileTypes(viewIndex)"
                  ></mat-icon>
                </div>
              </div>
              <div class="add-item-container">
                <div
                  class="add-item-div"
                  (click)="addSelectedCadFileTypes()"
                  *ngFor="
                    let selectedCadFileTypeView of selectedCadFileTypeViews;
                    let isLast = last
                  "
                >
                  <mat-icon
                    *ngIf="isLast"
                    class="product-add-icon"
                    svgIcon="eh-add"
                  ></mat-icon>
                  <span *ngIf="isLast" class="add-item-span">{{
                    t("eh-mydocuments-cad-addview")
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="show-more-container"
            (click)="showMoreAndLessDocumentTypes()"
          >
            <mat-icon class="show-more-arrow" *ngIf="!showMoreDocuments"
              >keyboard_arrow_down</mat-icon
            >
            <mat-icon class="show-more-arrow" *ngIf="showMoreDocuments"
              >keyboard_arrow_up</mat-icon
            >
            {{
              showMoreDocuments
                ? t("eh-mydocuments-reduce")
                : t("eh-mydocuments-expand")
            }}
          </div>
        </div>
      </div>

      <br />

      <div
        class="step-buttons step-buttons-second"
        [ngClass]="[
          isEndOfWizard ? 'step-buttons-absolute' : 'step-buttons-fixed'
        ]"
      >
        <div class="step-buttons-center">
          <button
            (click)="trackBackStepDocument()"
            class="step-button-back step-first-button"
            mat-raised-button
            color="primary"
            matStepperPrevious
          >
            {{ t("eh-mydocuments-back") }}
          </button>
          <button
            (click)="trackNextStepDocument()"
            class="next-step-button step-second-button"
            [disabled]="!areDocumentTypesValid || !areCadDrawingsValid"
            mat-raised-button
            color="primary"
            matStepperNext
          >
            {{ t("eh-mydocuments-next") }}
          </button>
        </div>
      </div>
    </div>
  </mat-step>

  <mat-step label="{{ t('step3.eh-mydocuments-step3-selection') }}">
    <div *ngIf="isAuthError || callFailedIsShown" class="div-error">
      <h1 class="error-h1">{{ t("eh-mydocuments-error1") }}</h1>
    </div>
    <div class="mat-step-container-form">
      <div class="wizard-form">
        <h1 class="stepper-title">
          {{ t("step3.eh-mydocuments-step3-title") }}
        </h1>
        <app-export-structure
          [activeLanguageId]="activeLanguage"
        ></app-export-structure>
      </div>
      <br />
      <div
        class="step-buttons step-buttons-second"
        [ngClass]="[
          isEndOfWizard ? 'step-buttons-absolute' : 'step-buttons-fixed'
        ]"
      >
        <div class="step-buttons-center">
          <button
            (click)="trackBackStepLanguage()"
            class="step-button-back step-first-button"
            mat-raised-button
            color="primary"
            matStepperPrevious
          >
            {{ t("eh-mydocuments-back") }}
          </button>
          <button
            [routerLink]="['/complete']"
            [queryParams]="queryParams"
            (click)="getSaveUserEntries()"
            class="next-step-button step-second-button"
            mat-raised-button
            color="primary"
            [disabled]="!areExportSettingsComplete"
            data-cs-tracking-no-track="true"
          >
            {{ t("step3.eh-mydocuments-step3-create") }}
          </button>
        </div>
      </div>
    </div>
  </mat-step>
</mat-horizontal-stepper>
